import { Injectable, InjectionToken, Injector } from '@angular/core';
import * as i0 from "@angular/core";
export const PARAM_TRANSFORMERS = new InjectionToken('logging-param-transformers');
/**
 * Used to add additional logging details to log
 * messages
 * @export
 * @abstract
 * @class LoggerParamsTransformer
 */
export class LoggerParamsTransformer {
    /**
     * Returns true if the initialize function has been called.
     *
     * @readonly
     * @type {boolean}
     * @memberof LoggerParamsTransformer
     */
    get initialized() {
        return this._initizialied;
    }
    /**
     * Creates an instance of LoggerParamsTransformer.
     * Also calls initialize() after a setTimeout, to make sure DI has been initialized
     * @param {Injector} injector Injector for doing DI operations. To be used in initialize()
     * @memberof LoggerParamsTransformer
     */
    constructor(injector) {
        this.injector = injector;
        this._initizialied = false;
        setTimeout(() => {
            this.initialize();
            this._initizialied = true;
        });
    }
    /**
     * Override this function to perform all injection (using this.injector)
     * Setup of the transformer (actions or selects on a store, async operations, etc.) should be done here as well
     *
     * @memberof LoggerParamsTransformer
     */
    initialize() { }
    static { this.ɵfac = function LoggerParamsTransformer_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoggerParamsTransformer)(i0.ɵɵinject(i0.Injector)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoggerParamsTransformer, factory: LoggerParamsTransformer.ɵfac }); }
}
//# sourceMappingURL=logger-params.js.map